import React from 'react';

interface InlineHelpShortcutProps {
  onNavigate: (screen: string) => void;
  sectionId?: string;
  label?: string;
  originScreen?: string;
}

export default function InlineHelpShortcut({
  onNavigate,
  sectionId = 'submitting-project-details',
  label = 'Need help?',
  originScreen = 'customer-dashboard',
}: InlineHelpShortcutProps) {
  return (
    <div
      style={{
        margin: '12px 0',
        border: '1px solid #bae6fd',
        borderRadius: 10,
        background: '#f0f9ff',
        padding: '10px 12px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <div style={{ color: '#075985', fontSize: 14 }}>
        {label} Open the in-app Help Center for this step.
      </div>
      <button
        className="btn btn-secondary"
        onClick={() => {
          try {
            sessionStorage.setItem('cb.help.section', sectionId);
            sessionStorage.setItem('cb.help.origin', originScreen);
          } catch {}
          onNavigate('homeowner-help');
        }}
        style={{ whiteSpace: 'nowrap' }}
      >
        Open Help
      </button>
    </div>
  );
}

